module.exports = __webpack_public_path__ + "img/gonetwork2_icon11.f04f08a0.png";